const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = TPL => {
  new BLOCKS;
};

class BLOCKS {
  constructor() {
    this.zipaddr();
  }

  zipaddr() {
    setTimeout(()=>{
      const zipInput = document.querySelector('.p-postal-code');
      const lookupButton = document.getElementById('postal-lookup-btn');
      const hAdrElement = document.querySelector('.h-adr');
      if (!zipInput || !lookupButton || !hAdrElement) {
        console.error('YubinBango: DOM elements not found.');
        return;
      }

      zipInput.classList.remove('p-postal-code'); 
      lookupButton.addEventListener('click', function() {
        zipInput.classList.add('p-postal-code');
        const event = new Event('keyup', {
          bubbles: true,
          cancelable: true,
        });
        zipInput.dispatchEvent(event);

        setTimeout(() => {
          zipInput.classList.remove('p-postal-code');
        }, 100); 
      });
    }, 500);
  }
}

const jqInit = () => false;

export default function FORM () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('app.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}